import type { IAccessTokenProvider } from "../interfaces/IAccessTokenProvider";
import type { ILoginApi } from "../interfaces/ILoginApi";
import type { LoginStartDto, LoginVerifyDto } from "../../shared/LoginDtos";

// Login mit Code per E-Mail. Bei Erfolg wird das Token wie beim Hosted-UI-Login gespeichert,
// Heartbeat und Refresh der UserService laufen danach unveraendert.
export class LoginService {
  readonly api: ILoginApi;
  readonly tokenProvider: IAccessTokenProvider;

  constructor(api: ILoginApi, tokenProvider: IAccessTokenProvider) {
    this.api = api;
    this.tokenProvider = tokenProvider;
  }

  async isEmailKnown(email: string): Promise<boolean> {
    const res = await this.api.exists(email.trim());
    return res.known;
  }

  async start(email: string): Promise<LoginStartDto> {
    return await this.api.start(email.trim());
  }

  async verify(email: string, session: string, code: string): Promise<LoginVerifyDto> {
    const res = await this.api.verify(email.trim(), session, code.replace(/\s+/g, ""));
    if (res.success && res.token) {
      await this.tokenProvider.saveToken(res.token);
    }
    return res;
  }
}
